export const INST: 'cloud' | 'enterprise' = 'cloud';
